<nb-card>
  <nb-card-body class="p-2" style="min-height: 40px">
    <app-reactive-form-field
      *ngIf="!alertDescription?.length"
      label="Display Name"
      [required]="true"
      [showInfoAsTooltip]="false"
      labelSize="5"
      fieldId="name"
      fieldName="name"
      inputSize="7"
      placeholder="Enter unique name for the account"
      [customFormControl]="accountName"
      missingMsg="{{ vcsAccountType | titlecase }} account name is required!"
      invalidPatternMsg="{{
        vcsAccountType | titlecase
      }} account name should be a lowercase alphanumeric string and can only have hyphens"
      class="mt-4"
    ></app-reactive-form-field>
    <app-reactive-toggle
      *ngIf="vcsAccountType === 'GITHUB' && !alertDescription?.length"
      label="Do you have Github Enterprise?"
      labelSize="5"
      toggleSize="7"
      [showInfoAsTooltip]="false"
      [showFormDivider]="false"
      [customFormControl]="hostNameToggle"
      (change)="hostNameToggleEvent($event)"
    ></app-reactive-toggle>
    <app-reactive-form-field
      *ngIf="
        vcsAccountType === 'GITHUB' &&
        !alertDescription?.length &&
        hostNameToggle?.value
      "
      label="Custom Github Hostname"
      [required]="false"
      [showInfoAsTooltip]="true"
      labelSize="5"
      fieldId="hostName"
      fieldName="hostName"
      inputSize="7"
      placeholder="Enter enterprise host name"
      [customFormControl]="hostedOn"
      class="mt-4"
      tooltipText="Use 'github.com' for standard GitHub or your custom domain for GitHub Enterprise."
      invalidPatternMsg="Url should not contain protocol eg. http:// or https://"
    ></app-reactive-form-field>
    <app-user-note-alert
      *ngIf="alertDescription?.length && enableStepTwo"
      [type]="alertType"
      [title]="alertTitle"
      [description]="alertDescription"
    >
    </app-user-note-alert>
    <div
      *ngIf="
        enableStepTwo &&
        ['GITLAB', 'BITBUCKET'].includes(vcsAccountType) &&
        !webhookCreating &&
        !pollingWebhook
      "
    >
      <app-single-select-search
        [label]="
          vcsAccountType === 'BITBUCKET' ? 'Select Workspace' : 'Select Group'
        "
        [required]="true"
        [showInfoAsTooltip]="false"
        inputSize="7"
        labelSize="5"
        [options]="orgNames"
        (selectedChange)="getProjectKeyOptions(selectedOrgName?.value)"
        searchInputPlaceholder="Search {{
          vcsAccountType === 'BITBUCKET' ? 'Workspace' : 'Group'
        }}"
        selectInputPlaceholder="Select {{
          vcsAccountType === 'BITBUCKET' ? 'Workspace' : 'Group'
        }}"
        searchInputId="organizations"
        [loading]="loadingOrgNames"
        [disabledTooltip]="
          !loadingOrgNames && !orgNames?.length
            ? 'There are no ' +
              organizationKeyWordMap[vcsAccountType] +
              ' found for given token'
            : ''
        "
        [disabled]="loadingOrgNames || !orgNames?.length"
        [customFormControl]="selectedOrgName"
      ></app-single-select-search>
      <app-reactive-form-field
        *ngIf="vcsAccountType === 'BITBUCKET'"
        label="Select Project Key"
        [required]="true"
        [showInfoAsTooltip]="false"
        labelSize="5"
        fieldId="projectid"
        [select]="true"
        [loading]="loadingProjectKey"
        [disabled]="!projectKeyOptions?.length"
        [disabledMsg]="
          !loadingProjectKey && !projectKeyOptions?.length
            ? 'There are no project keys for selected account'
            : ''
        "
        [selectValues]="projectKeyOptions"
        fieldName="projectid"
        inputSize="7"
        placeholder="Select Project Key"
        missingMsg="Project Key is required"
        [customFormControl]="projectId"
        class="mt-4"
      ></app-reactive-form-field>
    </div>
  </nb-card-body>
  <nb-card-footer
    class="p-0 pt-3 d-flex justify-content-between align-items-center"
  >
    <div>
      <app-rbac-button
        *ngIf="!alertDescription?.length || accountCreateError"
        [label]="enableStepTwo ? 'Linking In Progress' : 'Link'"
        class="mr-3"
        status="primary"
        [action]="ACCOUNTS_WRITE"
        [loading]="webhookCreating || pollingWebhook"
        [disabled]="!accountForm?.valid || webhookCreating || pollingWebhook"
        (onClick)="showNextStep()"
      ></app-rbac-button>
      <app-rbac-button
        *ngIf="
          ['GITLAB', 'BITBUCKET'].includes(vcsAccountType) &&
          alertDescription?.length &&
          !accountCreateError &&
          !orgsLinkedToAccount &&
          !webhookCreating &&
          !pollingWebhook
        "
        label="Save Details"
        class="mr-3"
        status="primary"
        [action]="ACCOUNTS_WRITE"
        [loading]="updatingVcsAccount"
        [disabled]="updatingVcsAccount || !orgNameForm?.valid"
        (onClick)="updateVcsAccount()"
      ></app-rbac-button>
      <app-rbac-button
        *ngIf="allowCancel"
        [label]="
          alertDescription?.length &&
          (githubAccountCreated || nonGithubAccountUpdated)
            ? 'Done'
            : 'Cancel'
        "
        [action]="undefined"
        [status]="
          alertDescription?.length &&
          (githubAccountCreated || nonGithubAccountUpdated)
            ? 'primary'
            : 'control'
        "
        size="small"
        class="mr-3"
        (click)="onClickHandleCancel(passedRef)"
      >
      </app-rbac-button>
    </div>
    <div *ngIf="['GITHUB', 'GITLAB'].includes(vcsAccountType ?? '')">
      <a
        style="
          text-decoration: none;
          color: var(--color-primary-active);
          cursor: pointer;
        "
        (click)="changeIntegrationMethod()"
      >
        Link using Personal Access Token
      </a>
    </div>
  </nb-card-footer>
</nb-card>
